import './App.css';
import PhotographyWebsite from './homepage';

function App() {
  return (
    <div className="App">
      <PhotographyWebsite></PhotographyWebsite>
    </div>
  );
}

export default App;
